import { Component, OnInit, ViewChild, AfterViewInit } from "@angular/core";
import { locale as en } from "../i18n/en";
import { locale as fr } from "../i18n/fr";
import { locale as de } from "../i18n/de";
import { locale as pt } from "../i18n/pt";
import { CoreTranslationService } from "@core/services/translation.service";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { CoreConfigService } from "@core/services/config.service";
import { ColumnMode, DatatableComponent, id } from "@swimlane/ngx-datatable";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Router } from "@angular/router";
import { ApiService } from "app/main/services/Api/api.service";
import { HttpErrorResponse } from "@angular/common/http";
import { forkJoin } from "rxjs";
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { ToastService } from "app/main/services/Toast/toast.service";

@Component({
  selector: "app-offers",
  templateUrl: "./offers.component.html",
  styleUrls: ["./offers.component.scss"],
})
export class OffersComponent implements OnInit {
  public contentHeader: object;
  offerStateForm: FormGroup;
  offerForm: FormGroup;

  /**
   *
   * @param {CoreTranslationService} _coreTranslationService
   */
  constructor(
    private _coreTranslationService: CoreTranslationService,
    private modalService: NgbModal,
    private api: ApiService,
    private formBuilder: FormBuilder,
    public toastService: ToastService,
  ) {
    this._coreTranslationService.translate(en, fr, de, pt);

    this.offerStateForm = this.formBuilder.group({
      id: ["", [Validators.required]],
      isEnabled: [Boolean, [Validators.required]],
    });

    this.offerForm = this.formBuilder.group({
      id: [""],
      eventId: [[""], [Validators.required]],
      discount: [
        0,
        [Validators.required, Validators.min(1), Validators.max(99)],
      ],
      isEnabled: [true, [Validators.required]],
      isGeneral: [false, [Validators.required]],
      code: ["", [Validators.required]],
      expiryDate: ["", [Validators.required]],
    });
    this.offerForm.get("isGeneral")?.valueChanges.subscribe((isGeneral) => {
      const eventControl = this.offerForm.get("eventId");

      if (isGeneral) {
        // يفضّي القائمة
        eventControl?.setValue([]);

        // يشيل الـ required
        eventControl?.clearValidators();
      } else {
        // يرجّع الـ required
        eventControl?.setValidators([Validators.required]);
      }

      // مهم جداً عشان يحدث حالة الفاليديشن
      eventControl?.updateValueAndValidity();
    });
  }

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */

  eventData: any;
  ngOnInit() {
    forkJoin({
      events: this.api.showAllEvents(1, 100),
      offers: this.api.showAllOffers(1, 100)
    }).subscribe({
      next: (results) => {
        this.eventData = results.events.data.map((item) => ({
          id: item.id,
          nameAr: item.nameAr,
          nameEn: item.nameEn,
        }));

        this.rows = results.offers.data.map((item, index) => ({
          id: item.id,
          "#": index + 1,
          eventNameEn: item.eventIds ? item.eventIds.map(id => this.eventData?.find(e => e.id === id)?.nameEn || id) : [],
          eventNameAr: item.eventIds ? item.eventIds.map(id => this.eventData?.find(e => e.id === id)?.nameAr || id) : [],
          code: item.code,
          discount: item.discount,
          isActive: item.isEnabled,
          isEnabled: item.isEnabled,
          howManyUsed: item.howManyIsUsed,
        }));
        this.temp = this.rows;
      },
      error: (error: HttpErrorResponse) => {
        console.error(error);
      },
    });

    document.getElementById("الرئيسية")?.classList.remove("active");
    document.getElementById("الفعاليات")?.classList.remove("active");
    document.getElementById("المشرفين")?.classList.remove("active");
    document.getElementById("المستخدمين")?.classList.remove("active");
    document.getElementById("طلبات المشرفين")?.classList.remove("active");
    document.getElementById("فئات المناسبات")?.classList.remove("active");
    // document.getElementById('الإشعارات')?.classList.remove('active')
    document.getElementById("المسئولين")?.classList.remove("active");

    this.columns = [
      {
        prop: "selected",
        name: "",
        sortable: false,
        canAutoResize: false,
        draggable: false,
        resizable: false,
        headerCheckboxable: true,
        checkboxable: true,
        width: 50,
      },
      { prop: "#" },
      { prop: "eventNameEn", name: "الفعالية" },
      { prop: "code", name: "كود العرض" },
      { prop: "discount", name: "نسبه الخصم" },
      { prop: "isActive", name: "الحالة" },
      { prop: "howManyUsed", name: "عدد مرات الاستخدام" },
      { prop: "" },
    ];

    this.contentHeader = {
      headerTitle: "العروض",
      actionButton: false,
    };
  }

  // table
  public readonly pageLimitOptions = [
    { value: 5 },
    { value: 10 },
    { value: 25 },
    { value: 50 },
    { value: 100 },
  ];
  public chkBoxSelected = [];
  public currentVisible: number = 3;
  public currentPageLimit: number = 10;
  rows = [];
  temp = [];
  @ViewChild(DatatableComponent) public table: DatatableComponent;
  ColumnMode = ColumnMode;
  columns = [];
  customChkboxOnSelect({ selected }) {
    this.chkBoxSelected.splice(0, this.chkBoxSelected.length);
    this.chkBoxSelected.push(...selected);
  }
  updateFilter(event: any) {
    const val = event?.target?.value ? event.target.value.toLowerCase() : "";

    // Filter data by checking all columns
    const temp = this.temp.filter((row) => {
      return Object.keys(row).some((key) =>
        row[key]?.toString().toLowerCase().includes(val),
      );
    });

    // Update the rows
    this.rows = temp;
    console.log(temp);
    // Reset to first page
    if (this.table) {
      this.table.offset = 0;
    }
  }
  public onLimitChange(limit: any): void {
    this.changePageLimit(limit);
    this.table.limit = this.currentPageLimit;
    this.table.recalculate();
    setTimeout(() => {
      if (this.table.bodyComponent.temp.length <= 0) {
        // TODO[Dmitry Teplov] find a better way.
        // TODO[Dmitry Teplov] test with server-side paging.
        this.table.offset = Math.floor(
          (this.table.rowCount - 1) / this.table.limit,
        );
        // this.table.offset = 0;
      }
    });
  }
  private changePageLimit(limit: any): void {
    this.currentPageLimit = parseInt(limit, 10);
  }
  public onVisibleChange(visible: any): void {
    this.currentVisible = parseInt(visible, 10);
  }

  // modal
  modalOpenDefault(modalDefault) {
    this.modalService.open(modalDefault, {
      centered: true,
    });
  }
  modalOpenLG(modalLG) {
    this.modalService.open(modalLG, {
      centered: true,
      size: "lg",
    });
  }
  deletedItemId: any;
  deleteItem(id: number) {
    console.log("Deleted Item ID:", id);
    this.deletedItemId = id; // Store ID for further actions
  }
  confirmDeleteItem() {
    if (this.deletedItemId) {
      this.api.deleteOffer(this.deletedItemId).subscribe({
        next: (response) => {
          if (response.success == true) {
            console.log(response);
            this.toastService.show("تم حذف العرض بنجاح ✅");
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          }
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.show("فعالية خطأ أثناء حذف العرض ❌");
        },
      });
    }
  }

  changeOfferState(id, isEnabled) {
    console.log(id);
    console.log(isEnabled);
    this.offerStateForm.patchValue({
      id: id,
      isEnabled: isEnabled,
    });
  }
  confirmChangeOfferState() {
    if (this.offerStateForm.valid) {
      this.api.changeOfferState(this.offerStateForm.value).subscribe({
        next: (response) => {
          if (response.success == true) {
            console.log(response);
            this.toastService.show("تم التعديل بنجاح ✅");
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          }
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.show("فعالية خطأ أثناء تغيير حالة العرض ❌");
        },
      });
    }
  }

  changeValue(e) {
    console.log(e.target.value);
    const number = parseFloat(e.target.value);
    this.offerForm.patchValue({
      discount: number,
    });
  }
  changeState(e) {
    console.log(e.target.value);
  }

  save() {
    // Mark all fields as touched to show validation messages
    this.offerForm.markAllAsTouched();

    if (this.offerForm.valid) {
      const formValue = { ...this.offerForm.value };
      if (formValue.expiryDate) {
        const expiryDate = new Date(formValue.expiryDate);
        formValue.expiryDate = expiryDate.toISOString();
      }
      if (formValue.isGeneral) {
        formValue.eventId = [];
      }
      console.log(formValue);
      this.api.addOffer(formValue).subscribe({
        next: (response) => {
          if (response.success == true) {
            console.log(response);
            this.toastService.show("تمت الاضافة بنجاح ✅");
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          } else {
            this.toastService.show(response.message);
          }
        },
        error: (error) => {
          console.log(error);
          this.toastService.show(error.error.message);
        },
      });
    } else {
      this.toastService.show("الرجاء إكمال جميع الحقول المطلوبة ❌");
    }
  }

  editItem(id) {
    if (id) {
      this.api.showOffer(id).subscribe({
        next: (response) => {
          this.offerForm.patchValue({
            id: response.data.id,
            eventId: response.data.eventIds,
            discount: response.data.discount,
            isEnabled: response.data.isEnabled,
            isGeneral: response.data.isGeneral,
            code: response.data.code,
            expiryDate: response.data.expiryDate ? response.data.expiryDate.substring(0, 16) : "",
          });
        },
        error: (error: HttpErrorResponse) => {
          console.log(error);
        },
      });
    }
  }
  update() {
    this.offerForm.markAllAsTouched();
    if (this.offerForm.valid) {
      const formValue = { ...this.offerForm.value };
      if (formValue.expiryDate) {
        const expiryDate = new Date(formValue.expiryDate);
        formValue.expiryDate = expiryDate.toISOString();
      }
      if (formValue.isGeneral) {
        formValue.eventId = [];
      }
      console.log(formValue);
      this.api.updateOffer(formValue).subscribe({
        next: (response) => {
          if (response.success == true) {
            console.log(response);
            this.toastService.show("تم التعديل بنجاح ✅");
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          }
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.show(error.error.message);
        },
      });
    }
  }

  reset() {
    this.offerForm.patchValue({
      id: "",
      eventId: "",
      discount: "",
      isEnabled: "",
      code: "",
      expiryDate: "",
    });
    // console.log(this.eventCatForm.value)
  }
}

